import i18next from 'i18next'

import {type NavigateOptions, useStableNavigate} from '../components/StableRouter'
import {useCurrentSpotSlug} from '../states/currentSpot'

import {useEvent} from './useEvent'

export function getFullUrl(to = ''): string {
  return `${document.location.origin}${to}`
}

export function getLangUrl(to = ''): string {
  return `/${i18next.resolvedLanguage}${to}`
}

export function getSpotUrl(slug: string, to = ''): string {
  return getLangUrl(`/spot/${slug}${to}`)
}

export function useSpotPath(): undefined | string {
  const slug = useCurrentSpotSlug()

  if (!slug) {
    return undefined
  }

  return getSpotUrl(slug)
}

export function useSpotUrl<T extends boolean = false>(to = '', fallbackToRoot?: T): T extends true ? string : undefined | string {
  const slug = useCurrentSpotSlug()

  if (!slug) {
    if (!(fallbackToRoot ?? false)) {
      return undefined as T extends true ? string : undefined | string
    }
    return getLangUrl(to)
  }

  return getSpotUrl(slug, to)
}

export function useSpotNavigate(): (to: string, options?: NavigateOptions) => void {
  const navigate = useStableNavigate()
  const spotPath = useSpotPath()

  return useEvent((to: string, options: NavigateOptions = {}): void => {
    navigate(`${spotPath}/${to}`, options)
  })
}
